import React, { Component } from 'react';

export default class View extends Component {
	render() {
		return (
			<div  style={{textAlign:'left', overflowWrap: 'break-word' }}>
				<h3 style={{textAlign:'center'}}>Failed to Cancel PA</h3>
				<hr/>
				<p>You’re not authorized to cancel this prior authorization. It was requested by a different prescriber.  </p>
			</div>
		);
	}
}